import { Logout } from "@State/actions/actionCreators";
import { Dispatch } from "redux";
import { clearAuthSession } from "@State/effects/security/login";
import getAPI from "@API/index";

export function logout() {
  return async (dispatch: Dispatch): Promise<void> => {
    await getAPI().request({
      method: "post",
      url: "/api/Auth/LogOut",
      suppressError: true,
      suppressSnackbar: true,
    });
    clearAuthSession();
    dispatch(Logout());
  };
}
